module.exports = __webpack_public_path__ + "img/9@2x.a4663cca.png";